const REQUIRED_UNIFORM_BLOCK_SIZE = 16_384;

function probeWebglMapSupport(): boolean {
  if (typeof document === "undefined") return false;
  try {
    const context = document.createElement("canvas").getContext("webgl2");
    if (!context) return false;
    const maxUniformBlockSize = Number(
      context.getParameter(context.MAX_UNIFORM_BLOCK_SIZE),
    );
    context.getExtension("WEBGL_lose_context")?.loseContext();
    return maxUniformBlockSize >= REQUIRED_UNIFORM_BLOCK_SIZE;
  } catch {
    return false;
  }
}

let probedSupport: boolean | null = null;

export function isWebglMapSupported(): boolean {
  probedSupport ??= probeWebglMapSupport();
  return probedSupport;
}
